module.exports = __webpack_public_path__ + "img/12.d0750c54.jpg";